import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { RecommendationsPage } from '../pages/RecommendationsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/recommendations')({
  component: Recommendations,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function Recommendations() {
  return (
    <MainLayout>
      <RecommendationsPage />
    </MainLayout>
  )
}
